import script from "./AddressBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBox.vue?vue&type=script&setup=true&lang=js"

import "./AddressBox.vue?vue&type=style&index=0&id=504e8284&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504e8284"]])

export default __exports__